var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRainmakerSoftIcon37User(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    viewBox: "0 0 33.1 33.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9 17.6h-8.7c-3.3 0-5.9 2.6-5.9 5.9v3.7c0 .5.2 1 .6 1.4.3.4.9.6 1.4.6H25c.5 0 1.1-.2 1.4-.6.3-.4.6-.9.6-1.4v-3.7c-.1-3.2-2.8-5.9-6.1-5.9zm4.5 9.7c0 .2-.1.3-.1.4-.1.1-.2.1-.3.1H8.2c-.1 0-.2 0-.3-.1-.1-.1-.1-.2-.1-.4v-3.7c0-1.2.5-2.3 1.3-3.1.8-.8 1.9-1.3 3.1-1.3h8.7c1.2 0 2.4.5 3.2 1.3.8.8 1.3 1.9 1.3 3.2v3.6zm-8.8-12c1.3 0 2.6-.5 3.5-1.3.9-.8 1.5-2 1.5-3.3V9.1c0-1.3-.6-2.5-1.5-3.3-.9-.8-2.2-1.3-3.5-1.3-1.3 0-2.6.5-3.5 1.3-.9.8-1.5 2-1.5 3.3v1.6c0 1.3.6 2.5 1.5 3.3.9.9 2.1 1.3 3.5 1.3zm-3.5-6.2c0-.9.4-1.7 1-2.2.6-.6 1.5-.9 2.5-.9s1.9.3 2.5.9c.6.6 1 1.3 1 2.2v1.6c0 .9-.4 1.7-1 2.2-.6.6-1.5.9-2.5.9s-1.9-.3-2.5-.9c-.6-.6-1-1.3-1-2.2V9.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainmakerSoftIcon37User);
export default __webpack_public_path__ + "static/media/Rainmaker_soft_icon_37_User.9f7240b0.svg";
export { ForwardRef as ReactComponent };